$('.categories_link').on('click', function (e) {
    e.preventDefault();
    var filter = $(this).data('filter');
    $('#download_container').children('div').each(function () {
     if (filter !== 'all') {
      if ($(this).data('filter') === filter) {
       $(this).css('display', 'block');
      } else {
       $(this).attr('style', 'display: none !important');
      }
     } else {
      $(this).attr('style', 'display: block');
     }
    });
   });


// WEBPACK FOOTER //
// ./scripts/routes/templateDownload.js


// WEBPACK FOOTER //
// ./scripts/routes/templateDownload.js